import React from 'react';
import { WHY_CHOOSE } from '../mock';
import * as Icons from 'lucide-react';

export default function WhyChoose() {
  return (
    <section id="why" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <div className="section-title-eyebrow uppercase">Why Choose Us</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">શા માટે </span><span className="gradient-text">One Stop Carz?</span>
          </h2>
          <p className="mt-4 text-gray-400">વડોદરાનું ભરોસાપાત્ર મલ્ટીબ્રાન્ડ કાર વર્કશોપ — ગુણવત્તા, પારદર્શિતા અને ભરોસો.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Ico = Icons[w.icon] || Icons.CheckCircle2;
            return (
              <div key={i} className="card-dark p-6 hover-lift">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{background:'linear-gradient(135deg,rgba(168,85,247,.15),rgba(236,72,153,.15))',border:'1px solid rgba(168,85,247,.35)'}}>
                  <Ico className="w-5 h-5 text-pink-400" />
                </div>
                <h3 className="font-semibold text-white text-[15px] mb-1.5">{w.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
